const ratingConstants = {
	MAX: 20,
	BASE_POINTS: 50,
	INITIAL: 0,
};

export default ratingConstants;
